import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import MainLayout from "./components/mainLayout";
import Dashboard from "./components/dashboard";
import { CssBaseline, StyledEngineProvider } from '@mui/material';

import themes from './themes';
import List from "./components/memberManagement/list";
import CreatUser from "./components/memberManagement/createUser";
import PointAdjustment from "./components/memberManagement/pointAdjustment";
import MemberInfo from "./components/memberManagement/memberInfo";
import SubAccounts from "./components/memberManagement/subAccounts";
import CreateSubAccount from "./components/sidebar/menu-items/createSubAccount";
import Login from "./components/login/login";
import PrivateRoute from "./components/privateRoute";
import MemberDetail from "./components/memberManagement/memberDetail";
import EditUser from "./components/memberManagement/editUser";
import EditSubAgent from "./components/memberManagement/editSubAgent";
import { LangProvider, pageContext } from './context';
import { useState } from "react";
import Statement from "./components/reports/statement";
import MatchResult from "./components/reports/matchResult";
import AcceptedBetsHdp from "./components/bets/acceptedBetsHdp";
import AcceptedBetsParlay from "./components/bets/acceptedBetsParlay";
import RejectedBets from "./components/bets/rejectedBets";
import BetDetail from "./components/bets/betDetail";
import WithdrawRequests from "./components/memberManagement/withdrawRequests";
import Slips from "./components/bets/slips";

function App() {
  const customization = useSelector((state) => state.customization);
  const [currentPages,setPages] = useState({memberManagementListPage: 1,subAgentListPage: 1});

  const changePages = (pageObj) =>{
    setPages({...currentPages,...pageObj})
  }
  return (
    // <BrowserRouter>
    <LangProvider>
    <pageContext.Provider value={{currentPages,changePages}}>
    <HashRouter>
      <ThemeProvider theme={themes(customization)}>
      <CssBaseline />
        <Routes>
         <Route path="/login" element={<Login/>}/>
         <Route element={<PrivateRoute/>}>
          <Route path="/" element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />}/>
             <Route path="/member-management/list" element={<List />}/>
             <Route path="/member-management/list/memberDetail" element={<MemberDetail />}/>
             <Route path="/member-management/list/editUser" element={<EditUser />}/>
             <Route path="/member-management/createUser" element={<CreatUser />}/>
             <Route path="/member-management/pointAdjustment" element={<PointAdjustment />}/>
             <Route path="/member-management/memberInfo" element={<MemberInfo />}/>
             <Route path="/member-management/subAccounts" element={<SubAccounts />}/>
             <Route path="/member-management/subAccounts/editSubAccounts" element={<EditSubAgent />}/>
             <Route path="/member-management/createSubAccount" element={<CreateSubAccount/>}/>
             <Route path="/member-management/withdrawRequests" element={<WithdrawRequests/>}/>
             <Route path="/reports/statement" element={<Statement/>}/>
             <Route path="/reports/matchResult" element={<MatchResult/>}/>
             <Route path="/bets/acceptedBetsHdp" element={<AcceptedBetsHdp/>}/>
             <Route path="/bets/acceptedBetsParlay" element={<AcceptedBetsParlay/>}/>
             <Route path="/bets/rejectedBets" element={<RejectedBets/>}/>
             <Route path="/bets/slips" element={<Slips/>}/>
             <Route path="/bets/betDetails" element={<BetDetail/>}/>
          </Route>
         </Route>
      </Routes>
      </ThemeProvider>
    </HashRouter>
    </pageContext.Provider>
    </LangProvider>
    // {/* // </BrowserRouter> */}
  );
}

export default App;
